/**
 * A picture.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readNumber, readString } from '@/domain/json'
import { type ImageSection } from '@/domain/section'
import ImageBlock from '@/sections/image/ImageBlock.vue'
import ImageInspector from '@/sections/image/ImageInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const imageSection: SectionDefinition<'image', ImageSection> = {
  kind: 'image',
  band: 'content',

  icon: ['M2.5 3.5h11v9h-11z', 'M2.5 10.5l3-3 2.5 2.5 2-2 3.5 3.5', 'M10.5 6a.6.6 0 1 0 0-.1'],

  create: (id, title) => ({
    id,
    kind: 'image',
    title,
    source: '',
    caption: '',
    width: 100,
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'image',
    title,
    source: readString(stored, 'source'),
    caption: readString(stored, 'caption'),
    width: readNumber(stored, 'width', 100),
  }),

  block: ImageBlock,
  inspector: ImageInspector,
}
